export * from './input-audio.component';
